var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"matrix-row-button has-text-weight-bold",class:( _obj = { active: _vm.isOn && !_vm.disabled }, _obj[_vm.code.code] = true, _obj ),style:({ '--color': _vm.color }),attrs:{"title":_vm.title,"disabled":_vm.disabled,"loading":_vm.toggling},on:{"click":_vm.toggle_}},[_vm._v("\n  "+_vm._s(_vm.code.code)+"\n")])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2846633e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CodesMatrixManager/partials/matrixRow.vue
// module id = null
// module chunks = 